import { RelationQueryBuilder } from '../builders/relationQueryBuilder';
export class BelongsTo extends RelationQueryBuilder {
}
//# sourceMappingURL=belongsTo.js.map